import React from 'react'
import ReactDOM from 'react-dom'
import Root from './views/Root'

import './utils/i18n'
import './styles/main.scss'
import './styles/animation.scss'
import 'mapbox-gl/dist/mapbox-gl.css';

import reportWebVitals from './reportWebVitals'
import moment from 'moment'
import {Chart} from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';
import 'chartjs-adapter-moment';
import {Toaster} from "react-hot-toast";
Chart.register(ChartDataLabels, annotationPlugin,  MatrixController, MatrixElement);


ReactDOM.render(
  <React.StrictMode>
      <Root/>
      <Toaster position="top-right"/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
//
